import { postRequest, getRequest, deleteRequest } from "../../helpers/request";

export const TYPES = {
  API_REQUEST: "API_REQUEST",
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",
  CLEAR_ERROR: "CLEAR_ERROR",

  GET_FOLDER_STRUCUTRE_SUCCESS: "GET_FOLDER_STRUCUTRE_SUCCESS",
  CREATE_PRESENTATION_SUCCESS: "CREATE_PRESENTATION_SUCCESS",
  GET_PRESENTATION_LIST_SUCCESS: "GET_PRESENTATION_LIST_SUCCESS",
  SHARE_PRESENTATION_SUCCESS: "SHARE_PRESENTATION_SUCCESS",
  UPDATE_PRESENTATION_SUCCESS: "UPDATE_PRESENTATION_SUCCESS",
  LIST_KEYMESSAGE_SUCCESS: "LIST_KEYMESSAGE_SUCCESS",
  CREATE_KEYMESSAGE_SUCCESS: "CREATE_KEYMESSAGE_SUCCESS",
  UPDATE_KEYMESSAGE_SUCCESS: "UPDATE_KEYMESSAGE_SUCCESS",
  UPDATE_BULK_KEYMESSAGE_SUCCESS: "UPDATE_BULK_KEYMESSAGE_SUCCESS",

  DELETE_PRESENTATION: "DELETE_PRESENTATION",
  DELETE_KEYMESSAGE: "DELETE_KEYMESSAGE",

  USER_LIST: "USER_LIST",

  GET_KEYMESSAGE_LIST_SUCCESS: "GET_KEYMESSAGE_LIST_SUCCESS",
  GET_FOLDER_STRUCTURE_SUCCESS: "GET_FOLDER_STRUCTURE_SUCCESS",
};

export const DROPDOWN_TYPES = {
  JSON_UPDATE_SUCCESS: "JSON_UPDATE_SUCCESS",
  VALIDATION_UPDATE_SUCCESS: "VALIDATION_UPDATE_SUCCESS",
  RESET_VALIDATION: "RESET_VALIDATION",
};

export const clearError = () => async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_ERROR });
};

export const apiResponse = (error, msg) => async (dispatch) => {
  dispatch({ type: error ? TYPES.API_ERROR : TYPES.API_SUCCESS, data: msg });
};

export const getFolderStructure = () => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await getRequest(`imports/structure`);
    if (data.isSuccess) {
      dispatch({
        type: TYPES.GET_FOLDER_STRUCUTRE_SUCCESS,
        data: data.structures,
      });
    } else {
      if (data.msg) {
        alert(data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    // dispatch({ type: TYPES.API_ERROR, error: error });
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const getPresentationList = (initialDate, finalDate) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const queryParams = `?startDate=${initialDate}&endDate=${finalDate}`;
    const { data } = await getRequest(`imports${queryParams}`);
    if (data.isSuccess) {
      dispatch({
        type: TYPES.GET_PRESENTATION_LIST_SUCCESS,
        data: data.presentations,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    // dispatch({ type: TYPES.API_ERROR, error: error });
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const uploadImportZip =
  (formData, showImportTab1, showImportTab2, showImportTab3) =>
    async (dispatch) => {
      dispatch({ type: TYPES.API_REQUEST });
      try {
        const { data } = await postRequest(`imports/upload-zip`, formData, {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
          },
        });
        if (data.isSuccess) {
          if (data.keyMessages) {
            showImportTab2();
            dispatch({
              type: TYPES.GET_KEYMESSAGE_LIST_SUCCESS,
              data: data.keyMessages,
            });
          } else {
            showImportTab3();
            dispatch({
              type: TYPES.GET_FOLDER_STRUCTURE_SUCCESS,
              data: data.zipStructure,
            });
          }
        } else {
          showImportTab1();
          dispatch({ type: TYPES.CLEAR_ERROR });
          alert(data.msg);
        }
      } catch (error) {
        console.log(error);
        dispatch({ type: TYPES.CLEAR_ERROR });
        alert(error);
      }
    };

export const getZipStructure =
  (formData, showImportTab1, showImportTab2, showImportTab3) =>
    async (dispatch) => {
      dispatch({ type: TYPES.API_REQUEST });
      try {
        const { data } = await postRequest(
          `imports/get-zip-structure`,
          formData,
          {
            headers: {
              "x-access-token": localStorage.getItem("token"),
              "x-refresh-token": localStorage.getItem("refreshToken"),
              changeOrigin: true,
            },
          }
        );

        if (data.isSuccess) {
          showImportTab3();
          dispatch({
            type: TYPES.GET_FOLDER_STRUCTURE_SUCCESS,
            data: data.zipStructure,
          });
        } else {
          showImportTab1();
          dispatch({ type: TYPES.CLEAR_ERROR });
          alert(data.msg);
        }
      } catch (error) {
        console.log(error);
        dispatch({ type: TYPES.CLEAR_ERROR });
        alert(error);
      }
    };

export const createPresentation = (formData, showTab3Error = null) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    let response;
    if (formData.pId) {
      response = await postRequest(`imports/${formData.pId}`, formData, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      });
    } else {
      response = await postRequest(`imports`, formData, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      });
    }

    // console.log(response);
    if (response.data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_PRESENTATION_SUCCESS,
        data: response.data.updatedPresn,
      });
    } else {
      if (response.data.isMainCssJsIssue) {
        dispatch({ type: TYPES.CLEAR_ERROR });
        showTab3Error(response.data.keyMessagesWithIssues);
      } else {
        dispatch({ type: TYPES.CLEAR_ERROR });
        alert(response.data.msg);
      }
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updateJSON =
  (keyValue, dataToUpdate, isPlugins = false, isShared = false) =>
    async (dispatch) => {
      dispatch({
        type: DROPDOWN_TYPES.JSON_UPDATE_SUCCESS,
        data: { keyValue, dataToUpdate, isPlugins, isShared },
      });
    };
export const updateFolderStructure =
  (updatedFolderStructure) => async (dispatch) => {
    dispatch({
      type: TYPES.GET_FOLDER_STRUCTURE_SUCCESS,
      data: updatedFolderStructure,
    });
  };

export const updateValidationData = (title, item) => async (dispatch) => {
  dispatch({
    type: DROPDOWN_TYPES.VALIDATION_UPDATE_SUCCESS,
    data: { title, item },
  });
};

export const resetValidationData = () => async (dispatch) => {
  dispatch({
    type: DROPDOWN_TYPES.RESET_VALIDATION,
  });
}

export const deletePresentation = (_id, name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await deleteRequest(`imports/${_id}`, {
      data: { name: name },
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });
    if (data.isSuccess) {
      dispatch({ type: TYPES.DELETE_PRESENTATION, data: _id });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    // handle delete error
    // dispatch({ type: TYPES.API_ERROR, error: error });
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const keyMessagesList = (id) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await getRequest(`imports/${id}/key-messages`);
    if (data.isSuccess) {
      dispatch({
        type: TYPES.LIST_KEYMESSAGE_SUCCESS,
        data: data.keyMessages,
      });
    } else {
      if (data.msg) {
        alert(data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    // dispatch({ type: TYPES.API_ERROR, error: error });
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const deleteKeyMessage = (_id, kmId, name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await deleteRequest(
      `imports/${_id}/key-messages/${kmId}`,
      {
        data: { name: name },
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      dispatch({
        type: TYPES.DELETE_KEYMESSAGE,
        data: { pId: _id, kmId: kmId },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    // handle delete error
    // dispatch({ type: TYPES.API_ERROR, error: error });
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const createExistingKeyMessage = (formData, pId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `imports/${pId}/key-messages/new`,
      formData,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_KEYMESSAGE_SUCCESS,
        data: data.keyMessage,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    // handle delete error
    // dispatch({ type: TYPES.API_ERROR, error: error });
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updateKeyMessage = (name, pId, kmId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `imports/${pId}/key-messages/${kmId}/update`,
      { name: name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );
    if (data.isSuccess) {
      dispatch({
        type: TYPES.UPDATE_KEYMESSAGE_SUCCESS,
        data: { name, pId, kmId },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    // dispatch({ type: TYPES.API_ERROR, error: error });
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const createKeyMessage = (formData, id, kmId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    let response;
    response = await postRequest(
      `imports/${id}/key-messages/${kmId}`,
      { name: formData },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (response.data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_KEYMESSAGE_SUCCESS,
        data: response.data.keyMessage,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const shareImportedPresentation = (pId, uId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `imports/${pId}/share`,
      { userId: uId },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );
    if (data.isSuccess) {
      dispatch({
        type: TYPES.SHARE_PRESENTATION_SUCCESS,
        data: { pId, sharedWithData: data.sharedWithData },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    // dispatch({ type: TYPES.API_ERROR, error: error });
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updatePresentation = (pId, name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `imports/${pId}/update`,
      { name: name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );
    if (data.isSuccess) {
      dispatch({
        type: TYPES.UPDATE_PRESENTATION_SUCCESS,
        data: { pId, name },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    // dispatch({ type: TYPES.API_ERROR, error: error });
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updateImportKeyMessageImage =
  (pId, kmId, formData) => async (dispatch) => {
    dispatch({ type: TYPES.API_REQUEST });
    try {
      const { data } = await postRequest(
        `imports/${pId}/key-messages/${kmId}/update-thumb`,
        formData,
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (data.isSuccess) {
        window.location.reload();
        dispatch({ type: TYPES.API_SUCCESS, data: "Image is updated" });
      } else {
        dispatch({ type: TYPES.API_ERROR, data: data.msg });
      }
    } catch (error) {
      console.log(error);
      // dispatch({ type: TYPES.API_ERROR, error: error });
      dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
    }
  };

export const importExistingKeyMessage =
  (formData, pId, kmId) => async (dispatch) => {
    dispatch({ type: TYPES.API_REQUEST });
    try {
      console.log(formData, pId, kmId);
      let response = await postRequest(
        `imports/${pId}/key-messages/${kmId}/new`,
        formData,
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
          },
        }
      );

      if (response.data.isSuccess) {
        dispatch({ type: TYPES.API_SUCCESS, data: response.data.msg });
        window.location.reload();
      } else {
        dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
      }
    } catch (error) {
      // dispatch({ type: TYPES.API_ERROR, error: error });
      console.log(error);
      dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
    }
  };

export const bulkUpdateKeymessage =
  (pId, replaceString, name) => async (dispatch) => {
    dispatch({ type: TYPES.API_REQUEST });
    try {
      const { data } = await postRequest(
        `imports/${pId}/bulkUpdate`,
        { replaceString: replaceString, updatedName: name },
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
          },
        }
      );

      if (data.isSuccess) {
        dispatch({
          type: TYPES.UPDATE_BULK_KEYMESSAGE_SUCCESS,
          data: data.keyMessage,
        });
      } else {
        dispatch({ type: TYPES.API_ERROR, data: data.msg });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
    }
  };
